import { JSX } from 'react'

import { Avatar } from '~/components/Avatar'
import { SupportedChainId } from '~/constants/chains'
import { useAddressLookup, useEnsAvatar } from '~/hooks/useENS'
import { useFarcasterLookup } from '~/hooks/useFarcaster'
import { IAddress } from '~/types'

export const SplitsAvatar = ({
  address,
  chainId,
  size = 16,
  className,
}: {
  address: IAddress
  chainId?: SupportedChainId
  size?: number
  className?: string
}): JSX.Element => {
  const { data: ens } = useAddressLookup(address, chainId)
  const { farcaster } = useFarcasterLookup(address)

  const ensAvatar = useEnsAvatar({ name: ens })

  return (
    <div className={className}>
      <Avatar
        address={address}
        image={farcaster?.pfp}
        fallbackImage={ensAvatar.avatar ?? undefined}
        size={size}
      />
    </div>
  )
}
